import { type TradeFee } from "#/types/fees";

export type TradeFeeKey = keyof TradeFee;

export interface TradeFeeItem {
  key: TradeFeeKey;
  label: string;
}

export const tradeFeeItems: readonly TradeFeeItem[] = [
  { key: "tradingFee", label: "Trading fee:" },
  { key: "systemicFee", label: "Systemic fee:" },
  { key: "totalFee", label: "Total fee:" },
] as const;
